export default __webpack_public_path__ + "static/media/tech-advisor.98498f63.png";